// Entry point for the build script in your package.json

import "./services/sentry";
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import Rails from "@rails/ujs";
import "./channels";
import "./controllers";
import { initAccordions } from "flowbite/lib/esm/components/accordion";
import { initTabs } from "flowbite/lib/esm/components/tabs";

Rails.start();
ActiveStorage.start();

document.addEventListener("turbo:load", () => {
  initAccordions();
  initTabs();
});

// All the theme JS has been removed, this could be refactored
import "./src/theme.js";
